<template>
  <div class="wrapper">
    <div
      class="item_menu"
      v-for="(item, index) in dataArray"
      :key="index"
      @click="menuCkicked(index)"
      :class="{ back_ground_avoid: index == 0 || index == 2 }"
    >
      <div
        class="item_label"
        :class="{
          selected_item: curentSelectIndex === index,
          back_ground_avoid: index == 0 || index == 2
        }"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curentSelectIndex: 1,
      dataArray: ['应用菜单权限', 'PC端']
    };
  },
  created() {
    let dict = {
      index: 1
    };
    this.$emit('applicationAuthorMenuClicked', dict);
  },
  methods: {
    menuCkicked(index) {
      if (index == 0 || index == 2) {
        return;
      }
      this.curentSelectIndex = index;
      let dict = {
        index: index
      };
      this.$emit('applicationAuthorMenuClicked', dict);
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
}

.item_menu {
  height: 48px;
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
}

.item_label {
  height: 40px;
  width: 100%;
  line-height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  color: #333333;
  background: white;
  font-size: 14px;
}

.selected_item {
  color: #ffffff;
  background: #1890ff;
}

.back_ground_avoid {
  background: #eef2f7;
  color: #333333;
}
</style>
